import {
    GENERIC_LOADER_UPDATE,
    GENERIC_DATA_VIEW_SET_SEARCH_PENDING_STATUS
} from '../constants';

const DEFAULT_STATE = {
    loaderType: 'boxes',
    loaderState: '',
    loaderCounter: 0,
    showText: false,
    showLoader: false,
    showGenericList: false,
    genericListItems: [],
    genericListLoaded: false,
    isSearching: false,
};

export const genericLoader = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case GENERIC_LOADER_UPDATE:
        case GENERIC_DATA_VIEW_SET_SEARCH_PENDING_STATUS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
